import { render } from "./xgpassword.vue?vue&type=template&id=31806cfa"
import script from "./xgpassword.vue?vue&type=script&lang=js"
export * from "./xgpassword.vue?vue&type=script&lang=js"

import "./xgpassword.vue?vue&type=style&index=0&id=31806cfa&lang=less"

import exportComponent from "F:\\ffile\\vscodeprj\\app\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__